import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

import { v4 } from 'uuid'
import { useGlobalState } from 'src/context/global'
import Doctors from '../../../../assets/Images/home-network-of-excellence.svg'
import { ContentSection } from '../../../structure'

const NetworkOfExcellenceTag = styled(ContentSection)`
  display: grid;
  grid-template-columns: auto;
  justify-items: center;
  max-width: 380px;
  margin-bottom: 8rem;
  padding-top: 4rem;

  @media ${mediaQueries.desktop} {
    margin-bottom: 4rem;
  }

  @media ${mediaQueries.desktop} {
    align-items: center;
    grid-column-gap: 2.5rem;
    grid-template-columns: auto auto;
    max-width: calc(960px + 4rem);
  }

  .left {
    line-height: 1.4;
    margin-bottom: 2rem;

    @media ${mediaQueries.desktop} {
      margin-bottom: 0;
    }

    h2 {
      color: ${palette.brand.darkGreen};
      font-size: 1.625rem;
      font-weight: 700;
      margin-bottom: 1.5rem;

      @media ${mediaQueries.desktop} {
        font-size: 1.875rem;
      }
    }
    p {
      color: ${palette.brand.darkGray};
      font-size: 1.125rem;
      font-weight: 600;

      @media ${mediaQueries.desktop} {
        font-size: 1.25rem;
      }
    }
    p:not(:last-child) {
      margin-bottom: 1.5rem;
    }
  }
`

export const NetworkOfExcellence = () => {
  const [{ appConfig }] = useGlobalState()
  const { networkOfExcellence } = appConfig

  return (
    <NetworkOfExcellenceTag>
      <div className="left">
        <h2>A network of excellence</h2>
        {networkOfExcellence.map(paragraph => (
          <p key={v4()}>{paragraph}</p>
        ))}
      </div>
      <div className="right">
        <img
          src={Doctors}
          alt="Four doctors, two men, one at each end and two women in the center."
        />
      </div>
    </NetworkOfExcellenceTag>
  )
}
